// Same labels and colors as the desktop products table
export const STATUS_LABELS: Record<string, string> = {
  AVAILABLE: 'Verfügbar', RESERVED: 'Reserviert', DRAFT: 'Entwurf', SOLD: 'Verkauft', ARCHIVED: 'Archiviert',
};
export const STATUS_COLORS: Record<string, string> = {
  AVAILABLE: 'green', RESERVED: 'orange', DRAFT: 'default', SOLD: 'red', ARCHIVED: 'default',
};

export const formatPrice = (priceCents: number | null | undefined): string =>
  `€${((priceCents || 0) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export interface MobileWatch {
  id: string;
  brand: string;
  model: string;
  priceCents: number;
  status: string;
  referenceNumber: string | null;
  sku: string | null;
  shortCode: string | null;
  images?: { thumbnailUrl?: string; originalUrl?: string }[];
}
